import React from 'react';
import { FormControl, FormErrorMessage, FormLabel, Input, InputProps } from '@chakra-ui/react';
import { FieldValues, UseFormRegister } from 'react-hook-form';

interface ColorInputFormProps extends InputProps {
  name: string | undefined | any;
  label: string | undefined;
  isRequired?: boolean;
  register: UseFormRegister<FieldValues>;
  errors: any;
}

export const ColorInputForm = ({
  name,
  label,
  isRequired,
  register,
  errors,
  ...rest
}: ColorInputFormProps) => {
  return (
    <FormControl isRequired={isRequired} isInvalid={!!errors[name]}>
      <FormLabel htmlFor={name}>{label}</FormLabel>
      <Input type="color" id={name} {...register(name)} {...rest} />
      {errors[name] && <FormErrorMessage>{errors[name]?.message}</FormErrorMessage>}
    </FormControl>
  );
};
